import { render, staticRenderFns } from "./PurposeComponent.vue?vue&type=template&id=0f043dc6&scoped=true&"
import script from "./PurposeComponent.vue?vue&type=script&lang=js&"
export * from "./PurposeComponent.vue?vue&type=script&lang=js&"
import style0 from "./PurposeComponent.vue?vue&type=style&index=0&id=0f043dc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f043dc6",
  null
  
)

export default component.exports